'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = exports.PREFIX = '@@redux-supermodel/';

var NUKE = exports.NUKE = PREFIX + 'NUKE';
var REQUEST = exports.REQUEST = PREFIX + 'REQUEST';
var RESET = exports.RESET = PREFIX + 'RESET';
var CLEAR_ERRORS = exports.CLEAR_ERRORS = PREFIX + 'CLEAR_ERRORS';

// AJAX Action Types
var PENDING = exports.PENDING = PREFIX + 'REQUEST_PENDING';
var FULFILLED = exports.FULFILLED = PREFIX + 'REQUEST_FULFILLED';
var REJECTED = exports.REJECTED = PREFIX + 'REQUEST_REJECTED';


//////////////////
// WEBPACK FOOTER
// ../dist/actionTypes.js
// module id = 327
// module chunks = 0